import { useEffect } from 'react';

import { selectRegisterCustomization } from '@/redux/customizations/reducers';
import { useAppSelector } from '@/redux/hooks';

export default function useRegistrationColors() {
  const customizations = useAppSelector(selectRegisterCustomization);

  useEffect(() => {
    document.body.style?.setProperty('--amba-register-background-color', customizations.background_color);
    document.body.style?.setProperty('--amba-register-button-color', customizations.button_color);
    document.body.style?.setProperty('--amba-register-button-text-color', customizations.button_text_color);

    return () => {
      document.body.style?.removeProperty('--amba-register-background-color');
      document.body.style?.removeProperty('--amba-register-button-color');
      document.body.style?.removeProperty('--amba-register-button-text-color');
    };
  }, [customizations]);

  return null;
}
